import { render, staticRenderFns } from "./SchemaContent.vue?vue&type=template&id=351f15b0&scoped=true"
import script from "./SchemaContent.vue?vue&type=script&lang=js"
export * from "./SchemaContent.vue?vue&type=script&lang=js"
import style0 from "./SchemaContent.vue?vue&type=style&index=0&id=351f15b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f15b0",
  null
  
)

export default component.exports